import 'component/css/paginator.css';

import { useState, useEffect } from 'react';
import Util from 'service/util';
import API from 'service/api';
import PopMessage from 'component/pop-msg/PopMessage';

import DatePicker from 'react-datepicker';

const today = Util.getToday();

function getKey(p,i)
{
  return `${p.company}:${p.srv_dis}${p.srv_loc}-${p.cd_plan}${p.vh_type}:${i}`;
}

const PlanHistoryRow = ({plan, setError, onUpdate, add, ...props}) =>
{
  const [effect, setEffect] = useState(today);
  const [price,  setPrice ] = useState(0);
  const [salary, setSalary] = useState(0);

  const submitPlan = (e) =>
  {
    if (!effect)
    {
      setError('日期無效，請重新輸入。');
      return false;
    }

    let { company, srv_dis, srv_loc, cd_plan, vh_type } = props;

    let dto = {
      company, srv_dis, srv_loc, cd_plan, vh_type
      ,...plan
      ,price
      ,salary
      ,effect: Util.ShortDate(effect)
      ,origin_effect: plan?.origin_effect && Util.ShortDate(plan.origin_effect)
    };

    e.target.disabled = true;
    API.editPlan(dto).then(resp => {
      if (resp.success)
      {
        PopMessage.show('已調整價格。', '成功', 'success');
        onUpdate();
      }
      else
      {
        setError(resp.msg);
        PopMessage.show(resp.msg, '失敗', 'danger');
      }
      e.target.disabled = false;
    });
  }

  //------------------------------
  // init
  useEffect(() => {
    if (plan)
    {
      setEffect(new Date(plan.effect));
      setSalary(plan.salary);
      setPrice (plan.price);
    } else {
      setEffect(today);
      setSalary(0);
      setPrice (0);
    }
  }, [plan]);

  //------------------------------
  // render
  return <div className="grid-row">
    <div className="plan-effect">
      <DatePicker selected={ effect } onChange={ setEffect }
                  dateFormat="yyyy-MM-dd" />
    </div>
    <div className="plan-price">
      <input value={price} type="number"
              onChange={ e=>setPrice( parseFloat(e.target.value || 0) ) } />
    </div>
    <div className="plan-salary">
      <input value={salary} type="number"
              onChange={ e=>setSalary( parseFloat(e.target.value || 0) ) } />
    </div>
    <div className="plan-created-date">{ !!plan && Util.ShortDate(Util.ShortDate(plan.create_dtm)) }</div>
    <div className="plan-created-by">{ plan?.create_by }</div>
    <div>
      { add
       ?<button className="btn small green" onClick={ submitPlan }>新增</button>
       :<button className="btn small blue" onClick={ submitPlan }>更新</button>
      }
    </div>
  </div>
}

//====================================================================

const PlanHistory = ({history, onUpdate, ...props}) =>
{
  const [error, setError]     = useState('');
  const [ls_hist, setHistory] = useState([]);

  //----------------------------
  // init
  useEffect(() => {

    let _hist = history.map(x => ({
      ...x
      ,origin_effect: new Date(x.effect)
      ,effect: new Date(x.effect)
    }));
    setHistory(_hist);

  }, [history]);

  return (
    <div className="plan-history">
      <div className="grid-row thead">
        <div className="plan-effect"      >生效日期</div>
        <div className="plan-price"       >月費</div>
        <div className="plan-salary"      >月薪</div>
        <div className="plan-created-date">修訂日</div>
        <div className="plan-created-by"  >修訂人</div>
        <div></div>
      </div>
      <PlanHistoryRow {...props} add setError={setError} onUpdate={onUpdate} />
      { ls_hist.map((h,i) =>
        <PlanHistoryRow key={getKey(h,i)}
          {...props} plan={h}
          setError={setError} onUpdate={onUpdate} />
      )}
      <div className="error-msg">
        { error }
      </div>
    </div>
  );
}

export default PlanHistory;